import api from "@/apis/AllocationReduceDepartmentAPI";
import Crud from "./crud-base";
var crud = new Crud("AllocationReduceDepartment", api);

const state = {
  ...crud.state,
  _config: {
    field: {
      key: "OrganizationUnitID",
      code: "OrganizationUnitCode",
      name: "OrganizationUnitName",
    },
  },
};
const getters = {
  ...crud.getters,
};
const mutations = {
  ...crud.mutations,
};

const actions = {
  ...crud.actions,
};

export default {
  debug: import.meta.env.PROD,
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
